/*
 * @description: 智能址解析
 */
import { useState, useCallback } from 'react';

export default function Model() {
  // 灰度控制
  const [grayScaleControlTips, setGrayScaleControlTips] =
    useState<boolean>(false);
  const setGrayScaleControlTipsM = useCallback((val) => {
    setGrayScaleControlTips(val);
  }, []);
  // 是否开启引导提示
  const [isShowAddressTips, setIsShowAddressTips] = useState<boolean>(false);
  const setIsShowAddressTipssM = useCallback((val) => {
    setIsShowAddressTips(val);
  }, []);
  // 解析弹窗
  const [addressAnalysisPopup, setAddressAnalysisPopup] =
    useState<boolean>(false);
  const setAddressAnalysisPopupM = useCallback((val) => {
    setAddressAnalysisPopup(val);
  }, []);
  // 选中的关键信息
  const [addressTipsConfig, setAddressTipsConfig] = useState<{
    index: number;
    type: 'addressAdd' | 'addressBook'; // 区分是下单、地址簿
  }>({
    index: -1,
    type: 'addressAdd',
  });
  const setAddressTipsConfigM = useCallback((val) => {
    setAddressTipsConfig(val);
  }, []);

  // 记录缓存
  const [addressRawData, setAddressRawData] = useState<any>({});
  const setAddressRawDataM = useCallback((val) => {
    setAddressRawData(val);
  }, []);

  return {
    grayScaleControlTips,
    setGrayScaleControlTipsM,
    isShowAddressTips,
    setIsShowAddressTipssM,
    addressAnalysisPopup,
    setAddressAnalysisPopupM,
    addressTipsConfig,
    setAddressTipsConfigM,
    addressRawData,
    setAddressRawDataM,
  };
}
